import {
  APP_DATA_REQUEST,
  APP_DATA_SUCCESS,
  APP_DATA_FAILURE,
  APP_CONFIG_REQUEST,
  APP_CONFIG_SUCCESS,
  APP_CONFIG_FAILURE,
} from '../actions/appActions';


export const status = (state = {
  configIsFetching: false,
  dataIsFetching: false,
}, action) => {
  switch (action.type) {
    case APP_CONFIG_REQUEST:
      return {
        ...state,
        configIsFetching: true,
      };
    case APP_CONFIG_SUCCESS:
    case APP_CONFIG_FAILURE:
      return {
        ...state,
        configIsFetching: false,
      };
    case APP_DATA_REQUEST:
      return {
        ...state,
        dataIsFetching: true,
      };
    case APP_DATA_SUCCESS:
    case APP_DATA_FAILURE:
      return {
        ...state,
        dataIsFetching: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/statusReducer.js